/* eslint-disable */
/*****************************************/
/* This file is automatically generated! */
/* Check static/build/css-to-js.js!      */
/*****************************************/

import _invert from "lodash/invert";

const COLOR = {
    "navy-black": "#051a3c",
    "navy-high": "#162d54",
    "navy-medium": "#5e6785",
    "navy-low": "#9caac0",
    "navy-grey": "#c2cad7",
    "navy-light-grey": "#d8dde6",
    "navy-lighter-grey": "#eff1f6",
    "navy-lightest-grey": "#f4f5f9",
    "navy-background": "#fafbfb",
    "navy-medium-8": "#051a3c14",
    white: "#fff",
    "white-87": "rgba(255, 255, 255, 0.87)",
    "white-60": "rgba(255, 255, 255, 0.6)",
    "white-32": "rgba(255, 255, 255, 0.32)",
    "white-24": "rgba(255, 255, 255, 0.24)",
    "white-12": "rgba(255, 255, 255, 0.12)",
    "white-8": "rgba(255, 255, 255, 0.08)",
    "white-4": "rgba(255, 255, 255, 0.04)",
    "indigo-dark": "#0031ca",
    indigo: "#3d5afe",
    "indigo-light": "#8187ff",
    "indigo-92": "#4d67fe",
    "indigo-76": "#6c82fe",
    "indigo-68": "#7b8ffe",
    "indigo-32": "#c1caff",
    "indigo-24": "#d0d7ff",
    "indigo-16": "#e0e5ff",
    "indigo-8": "#eff2ff",
    "indigo-4": "#f7f8ff",
    "indigo-light-fade-24": "rgba(129, 135, 255, 0.24)",
    "indigo-fade-24": "rgba(61, 90, 254, 0.24)",
    "indigo-fade-8": "rgba(61, 90, 254, 0.08)",
    "indigo-fade-4": "rgba(61, 90, 254, 0.04)",
    "teal-dark": "#009976",
    teal: "#00cba5",
    "teal-light": "#60ffd6",
    "teal-12": "#e0f9f4",
    "light-teal": "#f4fcfa",
    red: "#ce2e3a",
    "light-red": "#fbeeef",
    "dark-red": "#a4242e",
    "darker-red": "#8f2028",
    "red-orange": "#e86232",
    yellow: "#edaf1f",
    "mid-yellow": "#f7d37f",
    "light-yellow": "#fef9ed",
    "medium-green": "#13aa88",
    green: "#018576",
    "light-green": "#ebf5f4",
    "green-50": "#80c2bb",
    "medium-green-50": "#89d5c4",
    "medium-green-25": "#c4eae1",
    "yellow-50": "#f6d78f",
    "red-orange-50": "#f4b199",
    "red-50": "#e7979c",
    "space-grey": "#4a4a4a",
    "demon-grey": "#666",
    "slate-grey": "#9b9b9b",
    "mid-grey": "#bbb",
    "light-grey": "#ddd",
    "lightest-grey": "#f5f5f5",
    "hover-grey": "#f9f9f9",
    "cover-background": "rgba(0, 0, 0, 0.5)",
    "yellow-70": "rgba(237, 175, 31, 0.7)",
    "adp-red": "#e51938",
};

export default COLOR;

export const COLOR_LOOKUP = _invert(COLOR);
